// Generated by `yarn tokens:import --aos-ds` from the Figma "Navigation" icon section.
// Do not edit.
//
// Colour is not here on purpose: every path renders `currentColor`, so an icon
// takes its ink from `tone` like the rest of the package. The size is the one
// Figma draws at — the section holds 24px glyphs and 52px pictograms, and
// picking one for the other is not a decision this package makes.

import type { FigmaGlyph } from './glyph'

export const ChevronDown: FigmaGlyph = {
    name: 'ChevronDown',
    nodeId: '46:565',
    width: 24,
    height: 24,
    paths: [
        {
            d: 'M8.19693 9.10099L12.3989 13.325L16.6009 9.10099L17.8989 10.399L12.3989 15.899L6.89893 10.399L8.19693 9.10099Z',
            fillRule: 'evenodd',
            clipRule: 'evenodd',
        },
    ],
}
export const ChevronUp: FigmaGlyph = {
    name: 'ChevronUp',
    nodeId: '46:1437',
    width: 24,
    height: 24,
    paths: [
        {
            d: 'M15.803 14.899L11.601 10.675L7.39895 14.899L6.10095 13.601L11.601 8.10101L17.101 13.601L15.803 14.899Z',
            fillRule: 'evenodd',
            clipRule: 'evenodd',
        },
    ],
}
export const ChevronRight: FigmaGlyph = {
    name: 'ChevronRight',
    nodeId: '46:1438',
    width: 24,
    height: 24,
    paths: [
        {
            d: 'M9.0001 16.702L13.2241 12.5L9.00009 8.298L10.2981 7L15.7981 12.5L10.2981 18L9.0001 16.702Z',
            fillRule: 'evenodd',
            clipRule: 'evenodd',
        },
    ],
}
export const ChevronLeft: FigmaGlyph = {
    name: 'ChevronLeft',
    nodeId: '46:1439',
    width: 24,
    height: 24,
    paths: [
        {
            d: 'M15.798 8.298L11.574 12.5L15.798 16.702L14.5 18L9 12.5L14.5 7L15.798 8.298Z',
            fillRule: 'evenodd',
            clipRule: 'evenodd',
        },
    ],
}
